module.exports = __webpack_public_path__ + "static/media/alur-ukt.0f283b08.png";